<!-- Copyright (c) 2021 MOCA Systems, Inc.	All rights reserved. -->

<h1 mat-dialog-title>{{ strings.FORCE_REFRESH_DIALOG_TITLE }}</h1>

<mat-dialog-content>
	<p>{{ strings.FORCE_REFRESH_DIALOG_MESSAGE }}</p>
	<div *ngIf="!(webWorkerBackgroundLoadingDone | async)" class="refresh-loading-container">
		{{ strings.FORCE_REFRESH_LOADING }}
		<mat-spinner [diameter]="35"></mat-spinner>
	</div>
</mat-dialog-content>

<div mat-dialog-actions class="refresh-loading-actions">
	<button
		*ngIf="webWorkerBackgroundLoadingDone | async"
		mat-raised-button
		color="primary"
		(click)="onClick()"
		data-mdc-dialog-initial-focus
	>
		{{ strings.FORCE_REFRESH_DIALOG_BUTTON }}
	</button>
</div>
